import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as $ from 'jquery';
import { ConfigModel } from 'src/app/config/config.model';
import { ConfigService } from 'src/app/config/config.service';
import { ConfirmModalComponent } from 'src/app/core/components/confirm-modal/confirm-modal.component';
import { UserModel } from 'src/app/core/models/user.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { VerificaSesionME } from '../../open-api/model/verificaSesionME';
import { AccesoService } from '../../open-api';
import Swal from 'sweetalert2';
import { MenuModel } from 'src/app/core/models/menu.model';


@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  private sessionKey = 'token';
  @ViewChild('sidebar', { static: false }) sideBar!: ElementRef;
  @ViewChild('wrapper', { static: false }) wrapper!: ElementRef;
  user?: UserModel;
  configModel: ConfigModel = {};
  urlApi = '';
  urlAvatar = '';
  isCollapsed = false;
  menus:MenuModel[] =[];

  constructor(
    private authService: AuthService,
    private configService: ConfigService,
    private accesoService: AccesoService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    $('#menu-toggle').click((e) => {
      e.preventDefault();
      $('#wrapper').toggleClass('toggled');
    });
    
    this.GetConfig();
    this.GetUser();
  }


  toggleArrow() {
    this.isCollapsed = !this.isCollapsed;
  }

  GetConfig(): void {
    this.configService.config$.subscribe(config => {
      this.configModel = config;
      this.urlApi = config?.UrlApi || '';
      this.urlAvatar = config?.UrlAvatar || '';
    });
  }

  GetUser(): void {
    this.authService.user.subscribe(user => {
      this.user = user;
      this.user.menus?.forEach(m => {
          m.mostrarHijos = false;
      });
      this.menus =  this.user.menus?.filter(x=>
        x.esVisible
        ) || [];  
    });

  }

  LogOut(): void {
    Swal.fire({
      title: 'Cerrar Sesión',
      text: '¿Está seguro que desea cerrar la sesión?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: "#3b7851",
      cancelButtonColor: "#d33",
      confirmButtonText: "Salir",
      cancelButtonText:"Cancelar"
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.setItem(this.sessionKey, '');
        const parametro: VerificaSesionME = {
          idUsuario: this.user?.id,
          esMovil: false
        };
        this.accesoService.apiV10AccesoVerificaSesionPost(parametro).subscribe(() => {
          this.authService.LogOut();
        });
        this.authService.LogOut();
      }
    });
  }



  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const mobileBreakpoint = 768;
  
    if (window.innerWidth <= mobileBreakpoint) {
      const pageContentWrapper = document.getElementById('page-content-wrapper');
      
      if (pageContentWrapper && pageContentWrapper.contains(event.target as Node)) {
    
        const wrapper = document.getElementById('wrapper');
        if (wrapper) {
          if (wrapper.classList.contains('toggled')) {
            wrapper.classList.remove('toggled');
          } 
          
        }
      }
    }
  }

  OcultaMenu()
  {
    const mobileBreakpoint = 768;
  
    if (window.innerWidth <= mobileBreakpoint) {
      const wrapper = document.getElementById('wrapper');
      if (wrapper) {
        if (wrapper.classList.contains('toggled')) {
          wrapper.classList.remove('toggled');
        } 
        
      }
    }
  }
  

  
}
